import { render, staticRenderFns } from "./races.vue?vue&type=template&id=db0fbf66"
import script from "./races.vue?vue&type=script&lang=js"
export * from "./races.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports